const Footer = () => {
  const handleWhatsApp = () => {
    window.open("https://wa.me/5563991352552?text=Olá%2C%20gostaria%20de%20agendar%20uma%20consulta%20com%20a%20Dra.%20Fernanda.", "_blank");
  };

  return (
    <footer className="bg-textDark text-white py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="text-2xl font-serif font-bold mb-4">
              Dra. Fernanda<span className="text-accent">Palhares</span>
            </h3>
            <p className="text-gray-300 text-sm">
              Ginecologia e Obstetrícia com acolhimento, equilíbrio hormonal e respeito.
            </p>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Contato</h4>
            <div className="space-y-2 text-sm text-gray-300">
              <p>📞 <a href="tel:63991352552" className="hover:text-primary transition">(63) 99135-2552</a></p>
              <p>💬 <button onClick={handleWhatsApp} className="hover:text-primary transition cursor-pointer">WhatsApp (Clique aqui)</button></p>
              <p>✉️ <a href="mailto:drafernandapalharesgineco@gmail.com" className="hover:text-primary transition">drafernandapalharesgineco@gmail.com</a></p>
              <p>📍 <a href="https://share.google/1ls1Ktcbppey5gkkM" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition">Araguaína - TO</a></p>
            </div>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Horário de Atendimento</h4>
            <div className="space-y-1 text-sm text-gray-300">
              <p>Segunda a Sexta: 8h às 18h</p>
              <p>Sábado: 8h às 12h</p>
              <p className="text-textLight">Consultas com agendamento</p>
            </div>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Redes Sociais</h4>
            <div className="flex flex-col gap-3">
              <a 
                href="https://www.instagram.com/drafernandapalhares" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-white/10 px-4 py-2 rounded-full hover:bg-primary transition text-sm flex items-center justify-center gap-2"
              >
                📷 Instagram
              </a>
              <button
                onClick={handleWhatsApp}
                className="bg-green-600/30 px-4 py-2 rounded-full hover:bg-green-600 transition text-sm flex items-center justify-center gap-2"
              >
                💬 WhatsApp
              </button>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-700 pt-8 text-center text-gray-400 text-sm">
          <p>&copy; 2026 Dra. Fernanda Palhares. Todos os direitos reservados.</p>
          <p className="mt-2">CRM 3443 • RQE 2611 (Ginecologia/Obstetrícia)</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;